import { SellShippingModelType, SellShippingTypePriceInversed } from '@teinor/erp/types/company/order/sell/sellShipping'
import { useMemo } from 'react'
import { SellShippingModelTypeExtended } from '../types'
import ITHeaderText from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/Components/ITHeaderText'
import InputTableLeftColumnForm from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/InputTableLeftColumnForm'
import { InputTableLeftTabsProps } from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/types'
import { FormElement, FormRender } from '../../../../../../../../forms/FormRenderer/types'
import { parseAddressToOneLine } from '../../../../../../../../utils/globals/address'
import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import { getCurrencySymbol, prepareVatTag } from '../../../../../../../../utils/globals/price'
import { returnClassOfSpanTemplate } from '../../../../../../../../utils/globals/tailwind'
import useOrderShippingTypePrice from '../../../../../../../../utils/hooks/orders/useOrderShippingTypePrice'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import useOrderTypeShippingDict from '../../../../../../../../utils/hooks/orders/useOrderTypeShippingDict'
import '../sellHeader.sass'


type SellReadOnlyHeaderShippingProps = InputTableLeftTabsProps & SellReadOnlyHeaderShippingLogicProps & {
}

const SellReadOnlyHeaderShipping: React.FC<SellReadOnlyHeaderShippingProps> = ({ headerData, handleChange }) => {
    const { t } = useTwinTranslation()
    const { dictTypeShipping, dictTypePrice, memorizedAddress } = useSellReadOnlyHeaderShippingLogic({ headerData })
    const basicElements: FormElement<keyof SellShippingModelType | 'typeShipping'>[] = []
    const extraElements: FormElement<keyof SellShippingModelType>[] = []
    const SellTypeShippingInversed = {
        'sendToCustomer': 0,
        'pickUpStore': 1,
    }
    basicElements.push(
        {
            name: 'typeShipping',
            component: 'Custom',
            render: () => <ITHeaderText label={t('typeShipping', 'Tipo de envío')} value={dictTypeShipping[parseInt(String(headerData?.typeShipping))]?.name} className={returnClassOfSpanTemplate(2)} />
        }
    )
    if (headerData?.OrderShippingId && !headerData.typeShipping) {
        if (headerData.typeShipping === SellTypeShippingInversed['sendToCustomer']) {
            basicElements.push(
                {
                    name: 'ShippingAddressRelationId',
                    component: 'Custom',
                    render: ({ value, extraProps }) => <ITHeaderText label={t('shippingAddress', 'Dirección de envio')} value={memorizedAddress} className={returnClassOfSpanTemplate(2)} />,
                    extraProps: { memorizedAddress }
                },
                {
                    name: 'ShippingServiceId',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('shippingServices', 'Servicio de Transportista')} value={headerData?.OrderShipping?.ShippingService?.ShippingCompany?.name + ' - ' + headerData?.OrderShipping?.ShippingService?.name} className={returnClassOfSpanTemplate(2)} />,
                },
                {
                    name: 'customerPays',
                    component: 'Custom',
                    render: ({ value }) => {
                        return (
                            String(value) === 'true' ?
                                <ITHeaderText label={t('postage', 'Portes')} value={t('postageDue', 'Portes debidos')} className={returnClassOfSpanTemplate(2)} />
                                : null
                        )
                    },
                },
                {
                    name: 'numberPackages',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('numberPackages', 'Nº bultos')} value={value} className={returnClassOfSpanTemplate(1)} />,
                },
            )
            if (!headerData?.OrderShipping?.customerPays) {
                extraElements.push(
                    {
                        name: 'typePrice',
                        component: 'Custom',
                        render: ({ value }) => <ITHeaderText label={t('shippingCalculationS', 'Cálculo trans.')} value={dictTypePrice[parseInt(String(value))]?.name} className={returnClassOfSpanTemplate(1)} />,
                    }
                )
                if (headerData?.OrderShipping?.typePrice === SellShippingTypePriceInversed['introducePrice']) {
                    extraElements.push(
                        {
                            name: headerData.OrderShipping.priceVatIncluded ? 'finalPriceWithTax' : 'initialPriceWithoutTax',
                            component: 'Custom',
                            render: ({ value }) => <ITHeaderText label={t('priceToCustomer', 'Precio cliente')} value={value + getCurrencySymbol(headerData.CurrencyId) + ' - ' + prepareVatTag(headerData?.OrderShipping?.priceVatIncluded, t)} className={returnClassOfSpanTemplate(1)} />
                        }
                    )
                }
            }
            extraElements.push(
                {
                    name: 'weight',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('weight', 'Peso')} value={(value === '0' || value === undefined ? '-' : value) + ' ' + t('kg', 'kg')} className={returnClassOfSpanTemplate(1)} />
                }
            )
        }
    }
    const sections: FormRender<SellShippingModelTypeExtended> = [
        {
            cols: 2,
            elements: [
                ...basicElements,
                ...extraElements,

            ]
        }
    ]
    return (
        <InputTableLeftColumnForm form={sections} handleChange={handleChange} headerData={headerData?.OrderShipping} />
    )
}


interface SellReadOnlyHeaderShippingLogicProps {
    headerData: TwinDictionary
}

const useSellReadOnlyHeaderShippingLogic = ({ headerData }: SellReadOnlyHeaderShippingLogicProps) => {
    const memorizedAddress = useMemo(() => parseAddressToOneLine(headerData?.OrderShipping?.ShippingAddressRelation), [headerData?.OrderShipping?.ShippingAddressRelation])
    const dictTypeShipping = useOrderTypeShippingDict()

    const dictTypePrice = useOrderShippingTypePrice()

    return { dictTypeShipping, dictTypePrice, memorizedAddress }
}

export default SellReadOnlyHeaderShipping